<label class="field__label" *ngIf="showLabel">{{ 'setup.dailyLimitLabel' | transloco }}</label>
<div class="stepper-row">
  <div class="stepper">
    <button
      type="button"
      class="stepper__btn"
      [attr.aria-label]="'setup.dailyLimitDecrease' | transloco"
      (click)="decrement()"
    >
      −
    </button>
    <span class="stepper__value">{{ control.value }}</span>
    <button
      type="button"
      class="stepper__btn"
      [attr.aria-label]="'setup.dailyLimitIncrease' | transloco"
      (click)="increment()"
    >
      +
    </button>
  </div>
  <span class="stepper__unit">{{ 'setup.dailyLimitUnit' | transloco }}</span>
</div>
<div class="field__hint" *ngIf="showHint">{{ 'setup.dailyLimitHint' | transloco }}</div>
